import axios, { AxiosResponse } from 'axios'

import { env } from '@js/utils/env'
import gql from '@js/api/utils/gql'
import getStoreName from '@js/api/utils/getStoreName'
import getBearerToken from '@js/api/utils/getBearerToken'
import { CustomerProfile } from '@js/api/types/customer/CustomerProfile'

interface GetCustomerProfileResponse {
  data: {
    wceiGetCustomerProfile: CustomerProfile | null
  }
  errors?: [{ message: string }]
}

export const customerProfileQuery = gql`
  query wceiGetCustomerProfile {
    wceiGetCustomerProfile {
      customer_id
      first_name
      middle_name
      last_name
      email
      secondary_email
      customer_contact_number
      personal {
        address
        address_two
        city
        country
        phone
        phone_ext
        phone_type
        postcode
        secondary_phone
        state
      }
      professional {
        hear_about
        management_level
        employer_city
        employer_name
        employer_state
        primary_employment
        wc_certificates
      }
    }
  }
`

/**
 * @throws {string}
 *
 * Will throw one error message; Magento only returns one at a time, rather than an array of all errors.
 */
export const getCustomerProfile = async (customerId: number): Promise<CustomerProfile | null> => {
  const bearerToken = getBearerToken()

  const { data }: AxiosResponse<GetCustomerProfileResponse> = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
      Store: getStoreName(),
    },
    data: {
      query: customerProfileQuery,
      variables: {
        customerId,
      },
    },
  })

  if (data.errors) {
    throw data.errors[0].message
  }

  if (data.data.wceiGetCustomerProfile) {
    return data.data.wceiGetCustomerProfile
  }

  return null
}
